import { Helmet } from "react-helmet-async"
import { PGSettlements } from "../../../../Integrations"

export default function PGSettlementsPage() {
	return (
		<>
			<Helmet title="PG Settlements" />
			<PGSettlements />
		</>
	)
}
